export const getParams = function(args) {
  const params = [];
  if(args.c) {
    const c = typeof args.c === 'string' ? [args.c] : [...args.c];
    c.forEach(category => {
      params.push([`${args.categoryName}.id`, category]);
    });
  }
  if(args.s) params.push([ '_q', args.s ]);
  return params;
}
